import { render, staticRenderFns } from "./BackendUi.vue?vue&type=template&id=12de2dfd"
import script from "./BackendUi.vue?vue&type=script&lang=js"
export * from "./BackendUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports